import React, { useContext } from 'react';
import { StyleSheet } from 'react-native';
import { QuickFiltersContext } from './QuickFiltersProvider';
import {
  DNABox,
  DNACard,
  DNAText,
  DNAButton,
} from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';

const styles = StyleSheet.create({
  quickFiltersContainer: {
    padding: 12,
  },
  quickFiltersButton: {
    backgroundColor: colors['color-brand1-10'],
  },
});

const QuickFiltersHome : React.FC = () => {
  const { selectedPath, quickFilters, handleToggleFilter } = useContext(QuickFiltersContext);

  return (
    <DNACard appearance="outline" style={styles.quickFiltersContainer}>
      <DNABox alignY="center" spacing="sm">
        <DNAText bold>Find content:</DNAText>
        {quickFilters.map((filter, index) => {
          const isSelected = selectedPath === index;
          return (
            <DNAButton
              key={`${filter.id}-${index}`}
              testID="quickfilter-path"
              appearance="outline"
              status={isSelected ? 'secondary' : 'tertiary'}
              onPress={() => handleToggleFilter(filter.id, isSelected, index)}
              style={isSelected && styles.quickFiltersButton}
            >
              {filter.label}
            </DNAButton>
          )
        })}
      </DNABox>
    </DNACard>
  )
}

export default QuickFiltersHome;
